import { AspectRatio, Box, Grid } from '@chakra-ui/react';
import Image from 'next/image';
import { FC, Fragment, useMemo } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { getLectureVariant } from '@/components/ui/features/lecture/LectureHeaderSection/LectureHeaderSection.utils';
import { LecturePremiumOverlayButton } from '@/components/ui/features/lecture/LecturePremiumOverlayButton/LecturePremiumOverlayButton';
import { EpisodePremiumOverlayDesktop } from '@/components/ui/features/originals/EpisodesSection/components/EpisodePremiumOverlayDesktop';
import { LectureVariants } from '@/enums/LectureVariants';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useResource } from '@/lib/datx-jsonapi-react';

const FALLBACK_POSTER_PATH = '/images/landing/video-lectures.png';

export const LectureMediaLock: FC = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const lectureVariant = useMemo(() => getLectureVariant(lecture), [lecture]);

  const poster =
    lectureVariant === LectureVariants.Poster
      ? lecture?.largePosterDocumentThumbnailUrl || lecture?.largePosterDocumentThumbnailExtractUrl
      : lecture?.largePosterUrl;

  return (
    <Fragment>
      <EpisodePremiumOverlayDesktop posterUrl={poster || FALLBACK_POSTER_PATH} />
      <Box hideFrom="lg" position="relative">
        <AspectRatio maxW="full" ratio={3 / 2}>
          <Image
            style={{ opacity: 0.3 }}
            src={poster || FALLBACK_POSTER_PATH}
            alt="Lecture placeholder background"
            fill
          />
        </AspectRatio>
        <Grid w="full" h="full" placeItems="center" position="absolute" top="0" left="0">
          <LecturePremiumOverlayButton />
        </Grid>
      </Box>
    </Fragment>
  );
};
